import { API_BASE_URL, API_ENDPOINTS } from '../../config/constants';
import { CONFIG_PATH } from './constants';

export const loadConfigFromServer = async () => {
  const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.READ}?path=${encodeURIComponent(CONFIG_PATH)}`, {
    method: 'GET',
    mode: 'cors'
  });

  if (!response.ok) {
    throw new Error('Failed to load config');
  }

  const contentType = response.headers.get('content-type');
  let content;

  if (contentType && contentType.includes('application/json')) {
    const data = await response.json();
    content = data.content || data;
  } else {
    const text = await response.text();
    try {
      const data = JSON.parse(text);
      content = data.content || data;
    } catch (e) {
      content = text;
    }
  }

  // Parse the config content if it's a string
  if (typeof content === 'string') {
    return JSON.parse(content);
  } else if (typeof content === 'object') {
    return content;
  }

  return {};
};

export const saveConfigToServer = async (config) => {
  const configToSave = {
    customChecks: {
      requirements: config.customChecks?.requirements || ''
    },
    autoBurn: {
      enabled: config.autoBurn?.enabled ?? false
    },
    eslint: {
      enabled: config.eslint?.enabled ?? true,
      rules: config.eslint?.rules || ['no-unused-vars']
    },
    typescript: {
      enabled: config.typescript?.enabled ?? true
    },
    lineLimit: {
      enabled: config.lineLimit?.enabled ?? true,
      limit: config.lineLimit?.limit || 300,
      prompt: config.lineLimit?.prompt || 'Split any file with over {{ linelimit }} lines into smaller files.'
    },
    folderLimit: {
      enabled: config.folderLimit?.enabled ?? true,
      limit: config.folderLimit?.limit || 15,
      prompt: config.folderLimit?.prompt || 'Split any folder with over {{ folderlimit }} items into smaller, compartmentalized folders.'
    },
    testCheck: {
      enabled: config.testCheck?.enabled ?? false,
      patterns: config.testCheck?.patterns || { '.vue': '.test.js', '.jsx': '.test.jsx', '.tsx': '.test.tsx' },
      prompt: config.testCheck?.prompt || 'Create test files for components that are missing them.'
    }
  };

  const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.WRITE}`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      path: CONFIG_PATH,
      content: JSON.stringify(configToSave, null, 2)
    })
  });

  if (!response.ok) {
    throw new Error('Failed to save configuration');
  }

  return true;
};

export const disconnectFromServer = async () => {
  await fetch('${API_BASE_URL}/shutdown', {
    method: 'POST',
    mode: 'cors'
  });
};
